
    <!--
 * 横版-盲盒抽奖
 * @LastEditTime: Mon Feb 17 2025 18:24:03 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_JDH534"  :class="[`normal blind-box-page`,`u_c_JDH534`]" ><div id="u_c_I8LJ35"  v-html="compData.title" :class="[`${ compData.title ? 'text' : '' }`,`normal`,`u_c_I8LJ35`]" ></div><div id="u_c_NS9Z36"  v-html="compData.subTitle" :class="[`normal`,`u_c_NS9Z36`]" ></div><div id="u_c_S08364"  :class="[`normal`,`u_c_S08364`]" ><span id="u_c_M9B665"  :class="[`normal txt`,`u_c_M9B665`]" >{{`${ langData.myCoupon }:`}}</span><span id="u_c_KHHK67"  :class="[`normal txt count coupon-count`,`u_c_KHHK67`]" >{{`${ pageData.couponCount }`}}</span><a id="u_c_SSWG81" href="javascript:;" :class="[`normal txt award-btn`,`u_c_SSWG81`]" @click="u_c_SSWG81_event_MAWI24($event)">{{`[${ langData.checkGiftBtn }]`}}</a><a id="u_c_PMB269" href="javascript:;" :class="[`normal txt`,`u_c_PMB269`]" @click="u_c_PMB269_event_MAWI24($event)">{{`[${ langData.refresh }]`}}</a></div><div id="u_c_NO1G71"  :class="[`normal`,`u_c_NO1G71`]" ><div id="u_c_GAD717"  v-for="(giftItem, giftI) in compData.boxList" :key="giftI" :class="[`normal`,`u_c_GAD717`]" ><div id="u_c_L2HP72"  :style="`background-image:url(${ compData.giftPic })`" :class="[`${ giftItem.cur ? 'light' : '' }`,`normal`,`u_c_L2HP72`]" ></div></div></div><div id="u_c_S92S80"  :class="[`normal`,`u_c_S92S80`]" ><a id="u_c_KQKI48" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" v-if="!bridge.runInsdk()" :class="[`normal btn-light  go-store-btn`,`u_c_KQKI48`]" @click="u_c_KQKI48_event_MAWI24($event)"><div id="u_c_SJT649"  :class="[`normal page-common-btn`,`u_c_SJT649`]" >{{`${ langData.gotoStoreBtn }`}}</div></a><a id="u_c_SC7H76" href="javascript:;" :style="`background-image:url(${ pageData['lottery-btn-bg'] })`" :class="[`${ compData.canClick ? 'btn-light' : '' } ${ compData.is10 ? 'lottery-10-btn' : '' }`,`normal  lottery-btn`,`u_c_SC7H76`]" @click="u_c_SC7H76_event_334420($event)"><div id="u_c_KVV377"  v-show="!(compData.is10 && pageData.couponCount >= 10)" :class="[`normal page-common-btn`,`u_c_KVV377`]" >{{`${ compData.canClick ? langData.lotteryBtn : langData.inLottery }`}}</div><div id="u_c_QXB019"  v-show="compData.is10 && pageData.couponCount >= 10" :class="[`normal page-common-btn`,`u_c_QXB019`]" >{{`${ compData.canClick ? langData.lottery10 : langData.inLottery }`}}</div></a></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"subTitle":`活动期间，通过官网储值日储值满5美金，每日可获得3次机会开启盲盒`,"lotteryList":[{"name":"袜子1","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710074128890.png","kc":"","gl":""},{"name":"袜子2","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/1675418960221.png","kc":"","gl":""},{"name":"袜子3","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189606833.png","kc":"","gl":""}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115984-21.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`天使的选择
盲盒活动`,"is10":true,"isGSGL":false,"isGSKC":false},"en-US":{"subTitle":`During the event, every $7.99 you top up every day via official website will grant you a Lucky Ticket.`,"lotteryList":[{"name":"Dragon Orbs (Legendary)*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376686140590.png","kc":"50","gl":"0.230000"},{"name":"Flame of Condor*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376663701183.png","kc":"50","gl":"0.31"},{"name":"Feather of Condor*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376705831849.png","kc":"100","gl":"0.38"},{"name":"Crystal of Chaos*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376646298172.png","kc":"150","gl":"0.460000"},{"name":"Eagle's Cookie*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376798309057.png","kc":"300","gl":"0.76"},{"name":"Dragon Orbs (Unique)*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376624094048.png","kc":"500","gl":"2.29"},{"name":"Criticality Stone(Advanced)*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376633728567.png","kc":"","gl":"11.47"},{"name":"Reputation (500)*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376630412808.png","kc":"","gl":"19.11"},{"name":"Jewel of Life*2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376619858146.png","kc":"","gl":"26.760000"},{"name":"Garnet Jewel*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376798525153.png","kc":"","gl":"38.23"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115984-21.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Valentine's Day Pack`,"is10":true,"isGSGL":false,"isGSKC":false},"ru-RU":{"subTitle":`During the event, every $7.99 you top up every day via official website will grant you a Lucky Ticket.`,"lotteryList":[{"name":"Драконьи шары (Легендарные)*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376686140590.png","kc":"50","gl":"0.230000"},{"name":"Пламя Кондора*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376663701183.png","kc":"50","gl":"0.31"},{"name":"Перо Кондора*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376705831849.png","kc":"100","gl":"0.38"},{"name":"Кристалл Хаоса*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376646298172.png","kc":"150","gl":"0.460000"},{"name":"Печенье Орла*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376798309057.png","kc":"300","gl":"0.76"},{"name":"Драконьи шары (Уникальные)*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376624094048.png","kc":"500","gl":"2.29"},{"name":"Камень критичности (Усиленный)*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376633728567.png","kc":"","gl":"11.47"},{"name":"Репутация (500)*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376630412808.png","kc":"","gl":"19.11"},{"name":"Самоцвет Жизни*2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376619858146.png","kc":"","gl":"26.760000"},{"name":"Самоцвет Граната*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376798525153.png","kc":"","gl":"38.23"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115984-21.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Набор ко Дню Святого Валентина`,"is10":true,"isGSGL":false,"isGSKC":false},"pt-PT":{"subTitle":`During the event, every $7.99 you top up every day via official website will grant you a Lucky Ticket.`,"lotteryList":[{"name":"Orbes de Dragão (Lendário)*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376686140590.png","kc":"50","gl":"0.230000"},{"name":"Chama do Condor*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376663701183.png","kc":"50","gl":"0.31"},{"name":"Pena do Condor*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376705831849.png","kc":"100","gl":"0.38"},{"name":"Cristal do Caos*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376646298172.png","kc":"150","gl":"0.460000"},{"name":"Biscoito da Águia*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376798309057.png","kc":"300","gl":"0.76"},{"name":"Orbes de Dragão (Único)*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376624094048.png","kc":"500","gl":"2.29"},{"name":"Pedra de Criticidade (Avançada)*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376633728567.png","kc":"","gl":"11.47"},{"name":"Reputação (500)*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376630412808.png","kc":"","gl":"19.11"},{"name":"Joia da Vida*2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376619858146.png","kc":"","gl":"26.760000"},{"name":"Joia de Granada*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943376798525153.png","kc":"","gl":"38.23"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115984-21.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Pacote de Dia dos Namorados`,"is10":true,"isGSGL":false,"isGSKC":false}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '盲盒抽奖';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const initActivity = inject("initActivity", () => {})
const showTips = inject("showTips", (txt, code) => {})
const showGetSucc = inject("showGetSucc", (type, pic, name) => {})
const listData = inject("listData", {})
const canClickRefresh = inject("canClickRefresh", true)
const giftInfo = inject("giftInfo", {})
const getCurLink = inject("getCurLink", (link) => {})

const curPlatform = pagePlatform

watch(
  () => listData,
  (value) => {
    if (value && value.lotteryList) {
      let confList = _.cloneDeep(compData.lotteryList)
      compData.lotteryList = []
      value.lotteryList.forEach((item, index) => {
        if (confList[index]) {
          compData.lotteryList.push({
            ...confList[index],
            state: pageData.lotteryType == "no_reset" ? item.send_status : 0,
            id: item.id,
            cur: index ? 1 : 0,
          })
        }
      })
      giftInfo.lotteryAward = compData.lotteryList
    }
  }, {
    deep: true
  }
)

const init = () => {
  compData.canClick = true
  compData.storeLink = getCurLink(compData.storeLink)
  compData.boxList.forEach((item, index) => {
    item.cur = index ? 0 : 1
  })
}

init()

const getGiftName = (data) => {
  let name = ""
  if (data.send_type == "sendSerial") {
    name = `${langData.giftCode}：${data.send_value}`
  } else {
    let curId = compData.lotteryList.findIndex((item) => item.id == data.id)
    if (~curId) {
      name = compData.lotteryList[curId].name
    }
  }

  return name
}

const excLottery = async () => {
  let isMutiple = compData.is10 && pageData.couponCount >= 10
  let res = await excLotteryAjax(isMutiple)
  if (res.result != 1) {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
    return
  }

  let curGiftType = isMutiple ? "sendVt" : res.data.send_type
  let curGiftPic = isMutiple ? "" : compData.giftPic
  let curGiftName = ""
  let curUse = 0

  if (isMutiple) {
    for (let i in res.data) {
      if (res.data[i].id != 0) {
        curUse++
        curGiftName += `${getGiftName(res.data[i])}<br/><br/>`
      }
    }
    if (curUse < 10) {
      curGiftName = `${curGiftName}${langData.lottery10error.replace(
        /{{n}}/,
        String(curUse)
      )}`
    }
  } else {
    curGiftName = getGiftName(res.data)
  }

  let currentUse = isMutiple ? curUse : 1

  pageData.couponCount = +pageData.couponCount - currentUse
  pageData.lotteryTime = +pageData.lotteryTime + currentUse

  showGetSucc(curGiftType, curGiftPic, curGiftName)
  initActivity()
}

const excLotteryAjax = async (isMutiple) => {
  let curAction = isMutiple ? "batchLotteryAward" : "lotteryAward"
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, curAction), {
    params: JSON.stringify({
      language: curLang,
    }),
  })
  return res
}

// 盲盒轮闪
const TIMER = 500
let latestTime = new Date().getTime()
const updateLight = () => {
  let nowTime = new Date().getTime()
  if (nowTime - latestTime > TIMER) {
    latestTime = nowTime
    let latestIndex = compData.boxList.findIndex((item) => item.cur == 1)
    if (~latestIndex) {
      compData.boxList[latestIndex].cur = 0
      let nextIndex =
        latestIndex == compData.boxList.length - 1 ? 0 : latestIndex + 1
      compData.boxList[nextIndex].cur = 1
    }
  }
  window.requestAnimationFrame(updateLight)
}
updateLight();
      // 查看奖励按钮的click事件
      const u_c_SSWG81_event_MAWI24= async (e)=>{
        try {let arr = [];
compData.lotteryList.forEach(item => {
  let curName = item.name;
  let isn = false;
  if (compData.isGSGL) {
    curName += "\n";
    curName += `${langData.lotteryWeight}: ${item.gl}%`;
    isn = true;
  }
  if (compData.isGSKC) {
    if (!isn) {
      curName += "\n";
    }
    if (item.kc == '') {
      curName += ` ( ${langData.noCountLimit} ) `
    } else {
      curName += ` ( ${langData.curCount}${item.kc} ) `
    }
  }
  arr.push({
    name: curName,
    pic: item.pic
  })
})
pageData.seeGift = arr;
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 更新按钮的click事件
      const u_c_PMB269_event_MAWI24= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if(!canClickRefresh.value)return;
canClickRefresh.value = false;
initActivity();
await utils.sleep(5);
canClickRefresh.value = true;} catch (error) {console.log(error)}
      };
      // 去充钱的click事件
      const u_c_KQKI48_event_MAWI24= async (e)=>{
        try {window.activityDataLayer.push({
  eventName: 'click_button',
  eventType: '前往储值',
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
bridge.open(pageData.storeLink)
} catch (error) {console.log(error)}
      };
      // 抽奖按钮的click事件
      const u_c_SC7H76_event_334420= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if (!compData.canClick) return
compData.canClick = false
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "点击抽奖",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
await excLottery()
compData.canClick = true} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115924-30.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.default{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16715384791446.png);
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.default{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.default{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.default{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.default{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.default{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:2.92vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:76.35vw;

}
}.default{
.u_c_GAD717.normal{
position:relative;

}
}.default{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:27.03vw;
height:26.51vw;

}
}.default{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:-1.82vw;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_KQKI48.normal{
position:relative;
width:21.56vw;
height:7.40vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.default{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.88vw;

}
}.default{
.u_c_SC7H76.normal{
position:relative;
width:21.51vw;
height:7.34vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.default{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.08vw;

}
}.default{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.08vw;

}
}.en-US{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115924-30.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.en-US{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.en-US{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.en-US{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.en-US{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.en-US{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.en-US{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.en-US{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.en-US{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:2.92vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:76.35vw;

}
}.en-US{
.u_c_GAD717.normal{
position:relative;

}
}.en-US{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:27.03vw;
height:26.51vw;

}
}.en-US{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:-1.82vw;
display:flex;
justify-content:center;
align-items:center;

}
}.en-US{
.u_c_KQKI48.normal{
position:relative;
width:21.56vw;
height:7.40vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.en-US{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.88vw;

}
}.en-US{
.u_c_SC7H76.normal{
position:relative;
width:21.51vw;
height:7.34vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.en-US{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.08vw;

}
}.en-US{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.08vw;

}
}.ru-RU{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115924-30.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.ru-RU{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.ru-RU{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ru-RU{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ru-RU{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.ru-RU{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.ru-RU{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.ru-RU{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.ru-RU{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:2.92vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:76.35vw;

}
}.ru-RU{
.u_c_GAD717.normal{
position:relative;

}
}.ru-RU{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:27.03vw;
height:26.51vw;

}
}.ru-RU{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:-1.82vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ru-RU{
.u_c_KQKI48.normal{
position:relative;
width:21.56vw;
height:7.40vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.ru-RU{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.88vw;

}
}.ru-RU{
.u_c_SC7H76.normal{
position:relative;
width:21.51vw;
height:7.34vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.ru-RU{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.08vw;

}
}.ru-RU{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.08vw;

}
}.pt-PT{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115924-30.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.pt-PT{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.pt-PT{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.pt-PT{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.pt-PT{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.pt-PT{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.pt-PT{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.pt-PT{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.pt-PT{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:2.92vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:76.35vw;

}
}.pt-PT{
.u_c_GAD717.normal{
position:relative;

}
}.pt-PT{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:27.03vw;
height:26.51vw;

}
}.pt-PT{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:-1.82vw;
display:flex;
justify-content:center;
align-items:center;

}
}.pt-PT{
.u_c_KQKI48.normal{
position:relative;
width:21.56vw;
height:7.40vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.pt-PT{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.88vw;

}
}.pt-PT{
.u_c_SC7H76.normal{
position:relative;
width:21.51vw;
height:7.34vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.pt-PT{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.08vw;

}
}.pt-PT{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.08vw;

}
}
</style>
